import { call, put } from 'redux-saga/effects';

import { intl } from '@helpers/intl';
import { fetchEntityJurisdictionInfoSaga } from '@sagas/entityJurisdictions/fetchEntityJurisdictionInfoSaga';
import { entityJurisdictionInfoFailure } from '@store/entityJurisdictions/entityJurisdictionsDetail/entityJurisdictionInfo/entityJurisdictionInfo.reducer';

export const handleFetchEntityJurisdictionInfoRequest = function* ({ payload }) {
  try {
    yield call(fetchEntityJurisdictionInfoSaga, { payload });
  } catch (error) {
    const message =
      error.data?.nonFieldErrors ||
      intl.formatMessage({
        defaultMessage: 'Failed to fetch jurisdiction.',
        id: 'saga.jurisdiction.failure',
      });

    yield put(entityJurisdictionInfoFailure({ errorMessage: message }));
  }
};
